module.exports = __webpack_public_path__ + "img/social-data.0ff10841.svg";